import { createElementBlock, openBlock, createElementVNode, defineComponent, ref, watch, toValue, onBeforeUnmount, createBlock, Teleport, createVNode, createCommentVNode, Transition, withCtx, unref, normalizeStyle, resolveDynamicComponent, normalizeProps, mergeProps, normalizeClass, createTextVNode, toDisplayString } from "vue";
import { usePLoading } from "./usePLoading.js";
import { isComponent } from "./component.js";
import { _ as _export_sfc } from "./chunks/_plugin-vue_export-helper.js";
const _hoisted_1$1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1m0 19a8 8 0 1 1 8-8 8 8 0 0 1-8 8",
      opacity: ".25"
    }, null, -1),
    createElementVNode("path", {
      fill: "currentColor",
      d: "M10.14 1.16a11 11 0 0 0-9 8.92A1.59 1.59 0 0 0 2.46 12a1.52 1.52 0 0 0 1.65-1.3 8 8 0 0 1 6.66-6.61A1.42 1.42 0 0 0 12 2.69a1.57 1.57 0 0 0-1.86-1.53"
    }, [
      createElementVNode("animateTransform", {
        attributeName: "transform",
        dur: "0.75s",
        repeatCount: "indefinite",
        type: "rotate",
        values: "0 12 12;360 12 12"
      })
    ], -1)
  ]));
}
const PLoadingSpinner = { render };
const _hoisted_1 = {
  key: 0,
  class: "fixed left-0 top-0 z-[9999] flex w-full justify-center",
  "aria-live": "polite",
  "aria-busy": "true"
};
const _hoisted_2 = {
  key: 0,
  class: "invisible fixed"
};
const textDivClass = `flex h-8 justify-center gap-x-1.5 overflow-hidden whitespace-nowrap px-6 pt-1 text-sm font-semibold text-p-purple-60`;
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PLoading"
  },
  __name: "p-loading",
  setup(__props) {
    const { show, content, props: componentProps, loadingHide } = usePLoading();
    const dimsReference = ref(null);
    const width = ref(0);
    const height = ref(0);
    watch(
      () => toValue(content),
      () => {
        if (dimsReference.value) {
          width.value = dimsReference.value.offsetWidth;
          height.value = dimsReference.value.offsetHeight;
        }
      },
      { flush: "post" }
    );
    onBeforeUnmount(() => {
      loadingHide();
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Teleport, { to: "body" }, [
        createVNode(Transition, {
          name: "pm-backdrop-transition",
          "enter-active-class": "fadeInDown",
          "leave-active-class": "fadeOutUp"
        }, {
          default: withCtx(() => [
            unref(show) ? (openBlock(), createElementBlock("div", _hoisted_1, [
              createElementVNode("div", {
                style: normalizeStyle({ width: `${width.value}px`, height: `${height.value}px` }),
                class: "overflow-hidden rounded-b border-x border-b border-p-gray-30 bg-p-blue-10 shadow-sm transition-all duration-300"
              }, [
                createVNode(Transition, {
                  "enter-from-class": "opacity-0",
                  "enter-active-class": "transition duration-500"
                }, {
                  default: withCtx(() => [
                    unref(isComponent)(unref(content)) ? (openBlock(), createBlock(resolveDynamicComponent(unref(content)), normalizeProps(mergeProps({ key: 0 }, unref(componentProps))), null, 16)) : (openBlock(), createElementBlock("div", {
                      key: 1,
                      class: normalizeClass(textDivClass)
                    }, [
                      createVNode(unref(PLoadingSpinner), { class: "pt-0.5" }),
                      createTextVNode(" " + toDisplayString(unref(content)), 1)
                    ]))
                  ]),
                  _: 1
                })
              ], 4)
            ])) : createCommentVNode("", true)
          ]),
          _: 1
        }),
        unref(content) ? (openBlock(), createElementBlock("div", _hoisted_2, [
          createElementVNode("div", {
            ref_key: "dimsReference",
            ref: dimsReference
          }, [
            unref(isComponent)(unref(content)) ? (openBlock(), createBlock(resolveDynamicComponent(unref(content)), normalizeProps(mergeProps({ key: 0 }, unref(componentProps))), null, 16)) : (openBlock(), createElementBlock("div", {
              key: 1,
              class: normalizeClass(textDivClass)
            }, [
              createVNode(unref(PLoadingSpinner), { class: "pt-0.5" }),
              createTextVNode(" " + toDisplayString(unref(content)), 1)
            ]))
          ], 512)
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
const pLoading = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-9ad56d4f"]]);
export {
  pLoading as default
};
